import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormField, MatHint } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatInput, MatInputModule } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

export const DEFAULT_DEBOUNCE_TIME = 800;

@Component({
  selector: 'hk-search-field',
  template: `
    <mat-form-field class="m-1 flex w-full flex-1">
      <i matPrefix class="ph ph-magnifying-glass"></i>
      <input
        matInput
        type="text"
        [(ngModel)]="searchValue"
        (ngModelChange)="modelChange()"
        [placeholder]="placeholder"
        [autocomplete]="autocomplete"
        class="truncate text-sm placeholder:overflow-hidden placeholder:overflow-ellipsis placeholder:whitespace-nowrap"
        data-testid="searchField.input"
        [cdkTrapFocusAutoCapture]="autofocus"
        [cdkTrapFocus]="autofocus"
      />
      <button
        (click)="clearFilter()"
        [matTooltip]="'searchField.tooltipClearFilters' | translate"
        matTooltipTouchGestures="off"
        class="general close xs"
        data-testid="searchField.clearButton"
      >
        <i class="ph ph-backspace"></i>
      </button>
      <mat-hint *ngIf="hint">
        {{ hint }}
      </mat-hint>
    </mat-form-field>
  `,
  host: { class: 'flex' },
  imports: [MatHint, MatTooltip, FormsModule, MatFormField, MatInputModule, TranslateModule, MatInput, NgIf, A11yModule],
  standalone: true,
})
export class SearchFieldComponent {
  @Output() searchValueChange = new EventEmitter<string>();
  @Input() autofocus = false;
  @Input() placeholder = '';
  @Input() autocomplete = 'off';
  @Input()
  public searchValue = '';

  @Input()
  hint = '';

  public clearFilter() {
    this.searchValue = '';
    this.modelChange();
  }

  public modelChange() {
    this.searchValueChange.emit(this.searchValue);
  }
}
